<template>
  <div class="asc-alert-label--container">
    <asc-label
      size="md"
      :class="['asc-alert-label', bold ? 'asc-alert-label--bold' : '']"
      :value="value"
      :color="color"
    ></asc-label>
  </div>
</template>

<script>
import AscLabel from './AscLabel'

export default {
  name: 'AscAlertLabel',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-alert-label--container {
  & .asc-alert-label {
    margin-left: 8px;
  }

  & .asc-alert-label--bold {
    font-weight: bold;
  }
}
</style>
